export default "__VITE_ASSET__DrgB504S__"